(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["soffio-testimonianze"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soffio-testimonial-gallery')) {
    customElements.define('soffio-testimonial-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.sjgController) return;
        if (this.querySelector('[data-sjg-ready]')) {
          this.sjgMount();
          return;
        }
        this.sjgPending = new MutationObserver(() => {
          if (this.querySelector('[data-sjg-ready]')) this.sjgMount();
        });
        this.sjgPending.observe(this, { childList: true, subtree: true });
      }

      sjgMount() {
        this.sjgPending?.disconnect();
        if (this.sjgController) return;
        this.sjgController = new AbortController();
        const signal = this.sjgController.signal;
        this.sjgTrack = this.querySelector('[data-sjg-track]');
        this.sjgCards = [...this.querySelectorAll('[data-sjg-card]')];
        this.sjgLinks = [...this.querySelectorAll('[data-sjg-open]')];
        this.sjgDialog = this.querySelector('[data-sjg-dialog]');
        this.sjgImage = this.querySelector('[data-sjg-full]');
        this.sjgViewer = this.querySelector('[data-sjg-viewer]');
        this.sjgZoom = this.querySelector('[data-sjg-zoom]');
        this.sjgMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.sjgAnimations = new Set();
        this.sjgAutoButton = this.querySelector('[data-sjg-autoplay-toggle]');
        this.sjgUserPaused = false;
        this.sjgPauseReasons = new Set();
        this.sjgVisible = !('IntersectionObserver' in window);
        this.sjgPointerInside = false;
        this.sjgDelay = Math.max(3, Math.min(10, Number(this.dataset.sjgInterval) || 5)) * 1000;
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'touch') { this.sjgPointerInside = true; this.sjgPause('hover', true); }
        }, { signal });
        this.addEventListener('pointerleave', () => {
          this.sjgPointerInside = false;
          this.sjgPause('hover', false);
          this.sjgPause('pointer', false);
        }, { signal });
        this.addEventListener('pointerdown', () => this.sjgPause('pointer', true), { signal, passive: true });
        this.addEventListener('pointerup', () => this.sjgPause('pointer', false), { signal, passive: true });
        this.addEventListener('pointercancel', () => this.sjgPause('pointer', false), { signal, passive: true });
        this.addEventListener('focusin', () => this.sjgPause('focus', true), { signal });
        this.addEventListener('focusout', event => {
          if (!event.relatedTarget || !this.contains(event.relatedTarget)) this.sjgPause('focus', false);
        }, { signal });
        this.ownerDocument.addEventListener('visibilitychange', () => this.sjgRefreshAuto(), { signal });
        if ('IntersectionObserver' in window) {
          this.sjgVisibility = new IntersectionObserver(entries => {
            this.sjgVisible = entries[0].isIntersecting;
            this.sjgRefreshAuto();
          }, { threshold: [0, .1] });
          this.sjgVisibility.observe(this);
        }
        if (typeof this.sjgDialog.showModal === 'function') {
          this.querySelectorAll('[data-sjg-open]').forEach(link => {
            link.setAttribute('aria-haspopup', 'dialog');
            link.setAttribute('aria-controls', this.sjgDialog.id);
          });
        }

        this.addEventListener('click', event => this.sjgClick(event), { signal });
        this.sjgDialog.addEventListener('close', () => {
          this.sjgResetZoom();
          this.sjgPause('dialog', false);
          if (this.sjgLauncher?.isConnected) this.sjgLauncher.focus({ preventScroll: true });
        }, { signal });
        this.sjgDialog.addEventListener('click', event => {
          if (event.target !== this.sjgDialog) return;
          const box = this.sjgDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.sjgDialog.close();
        }, { signal });
        this.sjgTrack.addEventListener('scroll', () => this.sjgSchedule(), { passive: true, signal });
        this.sjgMotion.addEventListener('change', () => {
          if (this.sjgMotion.matches) this.sjgAnimations.forEach(animation => animation.cancel());
          this.sjgRefreshAuto();
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-sjg-card]');
          if (card && this.contains(card)) {
            this.sjgPause('editor', true);
            this.sjgScrollTo(this.sjgCards.indexOf(card));
          }
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => this.sjgPause('editor', false), { signal });

        if ('ResizeObserver' in window) {
          this.sjgResize = new ResizeObserver(() => this.sjgSchedule());
          this.sjgResize.observe(this.sjgTrack);
        }
        this.sjgUpdate();

        if (this.dataset.sjgAnimate === 'true' && !this.sjgMotion.matches && 'IntersectionObserver' in window) {
          this.sjgReveal = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              this.sjgReveal.unobserve(entry.target);
              this.sjgPlay(entry.target, 12, 420);
            });
          }, { threshold: .12 });
          this.querySelectorAll('[data-sjg-reveal]').forEach(element => this.sjgReveal.observe(element));
        }
      }

      sjgPlay(element, distance, duration) {
        if (this.dataset.sjgAnimate !== 'true' || this.sjgMotion.matches || typeof element.animate !== 'function') return;
        const animation = element.animate([
          { opacity: 0, transform: `translateY(${distance}px)` },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration, easing: 'cubic-bezier(.2,.65,.3,1)' });
        this.sjgAnimations.add(animation);
        animation.finished.catch(() => {}).finally(() => this.sjgAnimations.delete(animation));
      }

      sjgClick(event) {
        const opener = event.target.closest('[data-sjg-open]');
        if (opener && this.contains(opener) && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && typeof this.sjgDialog.showModal === 'function') {
          this.sjgShowMessage(this.sjgLinks.indexOf(opener));
          this.sjgLauncher = opener;
          try {
            this.sjgDialog.showModal();
          } catch {
            return;
          }
          event.preventDefault();
          this.sjgPause('dialog', true);
          this.sjgPlay(this.sjgDialog, 8, 180);
          return;
        }
        if (event.target.closest('[data-sjg-autoplay-toggle]')) {
          this.sjgUserPaused = !this.sjgUserPaused;
          if (!this.sjgUserPaused) {
            this.sjgPauseReasons.delete('focus');
            this.sjgPauseReasons.delete('hover');
          }
          this.sjgRefreshAuto();
        }
        if (event.target.closest('[data-sjg-close]')) this.sjgDialog.close();
        if (event.target.closest('[data-sjg-modal-previous]')) this.sjgShowMessage(this.sjgSelected - 1);
        if (event.target.closest('[data-sjg-modal-next]')) this.sjgShowMessage(this.sjgSelected + 1);
        if (event.target.closest('[data-sjg-zoom]')) {
          const zoomed = this.sjgDialog.toggleAttribute('data-sjg-zoomed');
          this.sjgZoom.setAttribute('aria-pressed', String(zoomed));
          this.sjgViewer.scrollTo({ left: 0, top: 0, behavior: 'instant' });
        }
        if (event.target.closest('[data-sjg-previous]')) this.sjgScrollTo(this.sjgCurrent - 1);
        if (event.target.closest('[data-sjg-next]')) this.sjgScrollTo(this.sjgCurrent + 1);
      }

      sjgShowMessage(index) {
        const link = this.sjgLinks[index];
        if (!link) return;
        this.sjgSelected = index;
        this.sjgImage.src = link.href;
        this.sjgImage.alt = link.dataset.sjgAlt || '';
        this.sjgImage.width = Number(link.dataset.sjgWidth) || 1277;
        this.sjgImage.height = Number(link.dataset.sjgHeight) || 337;
        this.sjgResetZoom();
        this.querySelector('[data-sjg-modal-counter]').textContent = `${index + 1} / ${this.sjgLinks.length}`;
        this.querySelector('[data-sjg-modal-previous]').disabled = index === 0;
        this.querySelector('[data-sjg-modal-next]').disabled = index === this.sjgLinks.length - 1;
        if (this.sjgDialog.open) this.sjgPlay(this.sjgViewer, 4, 160);
      }

      sjgResetZoom() {
        this.sjgDialog.removeAttribute('data-sjg-zoomed');
        this.sjgZoom.setAttribute('aria-pressed', 'false');
        this.sjgViewer.scrollTo({ left: 0, top: 0, behavior: 'instant' });
      }

      sjgStopAuto() {
        if (this.sjgTimer) clearTimeout(this.sjgTimer);
        this.sjgTimer = null;
      }

      sjgPause(reason, active) {
        if (!this.sjgPauseReasons) return;
        if (active) this.sjgPauseReasons.add(reason);
        else this.sjgPauseReasons.delete(reason);
        this.sjgRefreshAuto();
      }

      sjgRefreshAuto() {
        if (!this.sjgController || !this.sjgAutoButton) return;
        const available = this.dataset.sjgAutoplay === 'true' && this.sjgCards.length > 1 && this.sjgTrack.scrollWidth > this.sjgTrack.clientWidth + 4 && !this.sjgMotion.matches;
        this.sjgAutoButton.hidden = !available;
        this.sjgAutoButton.setAttribute('aria-pressed', String(this.sjgUserPaused));
        this.sjgAutoButton.textContent = this.sjgUserPaused ? this.sjgAutoButton.dataset.sjgPlayLabel : this.sjgAutoButton.dataset.sjgPauseLabel;
        const running = available && this.sjgVisible && !this.ownerDocument.hidden && !this.sjgUserPaused && !this.sjgPauseReasons.size && !this.sjgDialog.open;
        this.querySelector('[data-sjg-counter]').setAttribute('aria-live', running ? 'off' : 'polite');
        if (!running) { this.sjgStopAuto(); return; }
        if (this.sjgTimer) return;
        this.sjgTimer = setTimeout(() => {
          this.sjgTimer = null;
          if (!this.isConnected) return;
          const atEnd = Math.abs(this.sjgTrack.scrollLeft) >= this.sjgTrack.scrollWidth - this.sjgTrack.clientWidth - 4;
          this.sjgScrollTo(atEnd ? 0 : this.sjgCurrent + 1, atEnd);
          if (atEnd) this.sjgPlay(this.sjgTrack, 0, 200);
          this.sjgRefreshAuto();
        }, this.sjgDelay);
      }

      sjgScrollTo(index, immediate = false) {
        const card = this.sjgCards[Math.max(0, Math.min(index, this.sjgCards.length - 1))];
        if (!card) return;
        const trackBox = this.sjgTrack.getBoundingClientRect();
        const cardBox = card.getBoundingClientRect();
        const padding = parseFloat(getComputedStyle(this.sjgTrack).paddingInlineStart) || 0;
        this.sjgTrack.scrollTo({ left: this.sjgTrack.scrollLeft + cardBox.left - trackBox.left - padding, behavior: immediate || this.sjgMotion.matches ? 'instant' : 'smooth' });
      }

      sjgSchedule() {
        if (this.sjgFrame) return;
        this.sjgFrame = requestAnimationFrame(() => {
          this.sjgFrame = null;
          this.sjgUpdate();
        });
      }

      sjgUpdate() {
        const box = this.sjgTrack.getBoundingClientRect();
        const rtl = getComputedStyle(this.sjgTrack).direction === 'rtl';
        let nearest = 0;
        let distance = Infinity;
        const visible = [];
        this.sjgCards.forEach((card, index) => {
          const cardBox = card.getBoundingClientRect();
          const delta = Math.abs(rtl ? box.right - cardBox.right : cardBox.left - box.left);
          const overlap = Math.min(box.right, cardBox.right) - Math.max(box.left, cardBox.left);
          if (overlap >= cardBox.width * .8) visible.push(index);
          if (delta < distance) { distance = delta; nearest = index; }
        });
        this.sjgCurrent = nearest;
        const overflow = this.sjgTrack.scrollWidth > this.sjgTrack.clientWidth + 4;
        this.querySelector('[data-sjg-navigation]').hidden = !overflow;
        this.querySelector('[data-sjg-previous]').disabled = Math.abs(this.sjgTrack.scrollLeft) < 4;
        this.querySelector('[data-sjg-next]').disabled = Math.abs(this.sjgTrack.scrollLeft) >= this.sjgTrack.scrollWidth - this.sjgTrack.clientWidth - 4;
        const first = visible.length ? visible[0] : nearest;
        const last = visible.length ? visible[visible.length - 1] : nearest;
        const range = first === last ? `${first + 1}` : `${first + 1}–${last + 1}`;
        const counter = `${range} / ${this.sjgCards.length}`;
        const output = this.querySelector('[data-sjg-counter]');
        if (output.textContent !== counter) output.textContent = counter;
        if (!this.sjgCards.length) this.hidden = true;
        this.sjgRefreshAuto();
      }

      disconnectedCallback() {
        this.sjgPending?.disconnect();
        this.sjgResize?.disconnect();
        this.sjgReveal?.disconnect();
        this.sjgVisibility?.disconnect();
        this.sjgStopAuto();
        this.sjgController?.abort();
        this.sjgAnimations?.forEach(animation => animation.cancel());
        if (this.sjgFrame) cancelAnimationFrame(this.sjgFrame);
        if (this.sjgDialog?.open) this.sjgDialog.close();
        this.sjgController = null;
        this.sjgFrame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
